import { isValidUrl, isValidWebsite } from '@ctct/rise-utils';

const VALIDATION = {
  EMAIL: {
    pattern: {
      value: /\S+@\S+\.\S+/,
      message: 'You must enter a valid email address.',
    },
  },
  USERNAME: {
    pattern: {
      value: /^[a-zA-Z0-9\-_@.+]+$/,
      message: 'You must enter a valid username.',
    },
  },
  WEBSITE: {
    validate: (value: string): string | true => {
      if (!isValidWebsite(value)) return 'Enter a valid website';
      return true;
    },
  },
  URL: {
    validate: (value: string): string | true => {
      if (!isValidUrl(value)) return 'Please enter a valid URL';
      return true;
    },
  },
  IMAGE_URL: {
    validate: (value: string): string | true => {
      if (!isValidWebsite(value)) return 'Please enter a valid image URL';
      return true;
    },
  },
};

export { VALIDATION };
